import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where, updateDoc } from "firebase/firestore";
import { db } from "../../modules/auth/firebaseConfig";

export default function VerifyEmail() {
  const [status, setStatus] = useState("loading");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get("email")?.trim().toLowerCase();
    const tokenParam = params.get("token")?.trim();
    setEmail(emailParam || "");
    setToken(tokenParam || "");

    if (!emailParam || !tokenParam) {
      setStatus("error");
      setError("Missing or invalid verification link.");
      return;
    }

    async function verify() {
      try {
        const q = query(
          collection(db, "waitlist"),
          where("email", "==", emailParam),
          where("verificationToken", "==", tokenParam)
        );
        const snap = await getDocs(q);
        if (snap.empty) {
          setStatus("error");
          setError("Verification link is invalid or expired.");
          return;
        }
        const docRef = snap.docs[0].ref;
        await updateDoc(docRef, {
          verified: true,
          status: "verified"
        });
        setStatus("success");
      } catch (err) {
        setStatus("error");
        setError("Something went wrong: " + err.message);
      }
    }
    verify();
  }, []);

  // Auto-redirect after success
  useEffect(() => {
    if (status === "success") {
      const timer = setTimeout(() => {
        window.location.href = "/"; // your landing page route
      }, 2500); // 2.5 seconds
      return () => clearTimeout(timer);
    }
  }, [status]);

  if (status === "loading") {
    return (
      <div style={{color: "#fff", background: "#222836", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
        Verifying...
      </div>
    );
  }
  if (status === "success") {
    return (
      <div style={{color: "#fff", background: "#222836", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
        Your email has been verified! Thank you.<br />
        <span style={{fontSize: "0.9rem", marginTop: "10px"}}>Redirecting to Million2Trillion...</span>
      </div>
    );
  }
  return (
    <div style={{color: "#fff", background: "#222836", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
      Verification Error<br/>{error}
    </div>
  );
}
